export const DOUBLE_SYMBOLS = [
  "Fr",
  "Cr",
  "Tc",
  "Be",
  "Fe",
  "Xe",
  "Bh",
  "Sr",
  "Pt",
  "Ba",
  "Tm",
  "Mn",
  "Lv",
  "Li",
  "Cs",
  "Te",
  "Pr",
  "Tl",
  "Bk",
  "Bi",
  "Hf",
  "Hg",
  "Kr",
  "As",
  "Sc",
  "Rh",
  "Mt",
  "Er",
  "Ar",
  "Am",
  "Pd",
  "Cn",
  "Hs",
  "Mg",
  "Mc",
  "Ds",
  "Md",
  "Rg",
  "Cl",
  "Ir",
  "Pb",
  "Fl",
  "In",
  "Og",
  "Ti",
  "Fm",
  "Es",
  "Rf",
  "Si",
  "Cd",
  "Tb",
  "Ru",
  "He",
  "Ga",
  "Eu",
  "La",
  "Ra",
  "Pu",
  "Ge",
  "Br",
  "Cu",
  "Sg",
  "Ho",
  "Nd",
  "Rb",
  "Ca",
  "Cm",
  "Re",
  "Gd",
  "Nh",
  "Co",
  "Lu",
  "Rn",
  "Db",
  "Na",
  "Ta",
  "Yb",
  "Zr",
  "Pa",
  "Al",
  "Ce",
  "Lr",
  "Au",
  "Cf",
  "Th",
  "Np",
  "Sm",
  "Zn",
  "At",
  "Ts",
  "Nb",
  "Sn",
  "No",
  "Po",
  "Sb",
  "Ne",
  "Mo",
  "Ni",
  "Pm",
  "Dy",
  "Se",
  "Ag",
  "Os",
  "Ac",
]

export const SINGLE_SYMBOLS = [
  "V",
  "Y",
  "W",
  "N",
  "P",
  "C",
  "H",
  "K",
  "F",
  "U",
  "S",
  "O",
  "B",
  "I",
]
